import React from 'react';
import '../assets/scss/modal.scss';

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {children}
                {/* <button onClick={onClose}>LUKK</button> */}
            </div>
        </div>
    );
};

export default Modal;